import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

function UpdateIssue({ showMessage, id, setShowUpdate }) {
    const navigate = useNavigate();

    const [title, setTitle] = useState("");
    const [date, setDate] = useState("");
    const [dateRange, setDateRange] = useState("");
    const [image, setImage] = useState(null);
    const [pdf, setPdf] = useState(null);

    const fileImageRef = useRef(null);
    const filePdfRef = useRef(null);

    const [issue, setIssue] = useState(null);

    useEffect(() => {
        fetch(`https://annalsofnursing.org/aon_backend/api/api.php?action=getIssueById&id=${id}`)
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    setIssue(data.issue);
                    setTitle(data.issue.title);
                    setDate(data.issue.date);
                    setDateRange(data.issue.date_range);
                } else {
                    console.error(data.error);
                    showMessage("error", "Failed to load issue.");
                }
            });
    }, [id]);

    useEffect(() => {
        fetch('https://annalsofnursing.org/aon_backend/api/api.php?action=checkUserSession', {
            method: 'GET',
            credentials: "include",
        })
            .then(res => res.json())
            .then(data => {
                if (data.success !== 'true') {
                    navigate("/dashboard/login");
                }
            })
            .catch(err => console.error(err));
    }, []);

    const updateIssue = async () => {
        const hasChanged =
            title !== issue.title ||
            date !== issue.date ||
            dateRange !== issue.date_range ||
            image || pdf;

        if (!hasChanged) {
            showMessage("info", "Nothing has changed.");
            return;
        }

        const formData = new FormData();
        formData.append("id", id);
        formData.append("title", title);
        formData.append("date", date);
        formData.append("date_range", dateRange);
        if (image) formData.append("image", image);
        if (pdf) formData.append("pdf", pdf);

        try {
            const response = await fetch(`https://annalsofnursing.org/aon_backend/api/api.php?action=updateIssue`, {
                method: "POST",
                credentials: "include",
                body: formData,
            });

            const data = await response.json();
            if (data.success) {
                showMessage("success", "Issue updated successfully.");
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } else {
                showMessage("error", data.error || "Update failed.");
            }
        } catch (err) {
            console.error(err);
            showMessage("error", "An error occurred during update.");
        }
    };

    const cancelUpdateIssue = () => {
        setShowUpdate(false);
    };

    return (
        <div className="dash_update_records">
            <label>1. Title</label><br />
            <input className="dash_input" type="text" value={title} onChange={(e) => setTitle(e.target.value)} /><br />

            <label>2. Date</label><br />
            <input className="dash_input" type="date" value={date} onChange={(e) => setDate(e.target.value)} /><br />

            <label>3. Date Range</label><br />
            <input className="dash_input" type="text" value={dateRange} onChange={(e) => setDateRange(e.target.value)} /><br />

            <label>4. Upload New Image</label><br />
            <input ref={fileImageRef} className="dash_file_upload" type="file" onChange={(e) => setImage(e.target.files[0])} /><br />

            <label>5. Upload New PDF</label><br />
            <input ref={filePdfRef} className="dash_file_upload" type="file" onChange={(e) => setPdf(e.target.files[0])} /><br /><br />

            <div className="dash_buttons_wrapper">
                <button className="dash_form_buttom" onClick={updateIssue}>Update</button>
                <button className="dash_form_buttom dash_reset" onClick={cancelUpdateIssue}>Cancel</button>
            </div>
        </div>
    );
}

export default UpdateIssue;